import { Box, Button, OutlinedInput } from "@mui/material";
import { BackgroundStyle, BigHeading, FlexContainer, LightBlueContainer, ListContainer, SearchingBoxContainer, LongBlueButton } from "../assets/style";
import RecordTable, { TableRow, TableHeader } from "../components/RecordTable";
import { useState, useContext, useEffect } from "react";
import SearchInput from "../components/SearchInput";
import SearchDatePicker from "../components/SearchDatePicker";
import dayjs from 'dayjs';
import SearchBox from "../components/SearchBox";
import MainContent from '../components/MainContent';
import { useNavigate } from "react-router-dom";
import { projectPageName } from "../components/PageName";
import { useLazyGetProjectListingQuery } from "../features/project/projectSlice";
import { GlobalStateContext } from "../store/GlobalState";
import LogoutFunction from '../components/LogoutFunction';
import RecordTableV2 from "../components/RecordTableV2";
import { RecordModel } from "../models/RecordModel";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectPermissions } from "../features/auth/authSlice";
import { Permissions } from "../utils/Permissions";

const ProjectListPage = () => {
    const { t, i18n } = useTranslation();
    const [projectNumber, setProjectNumber] = useState("");
    const [contractNumber, setContractNumber] = useState("");
    const [contractTitle, setContractTitle] = useState("");
    const [startDate, setStartDate] = useState(dayjs(null));
    const [endDate, setEndDate] = useState(dayjs(null));
    const [projectName, setProjectName] = useState("");
    const [projectManager, setProjectManager] = useState("");
    const navigate = useNavigate();
    const [getProjectListingQuery] = useLazyGetProjectListingQuery();
    const globalState = useContext(GlobalStateContext);
    const columns: TableHeader[] = [
        { field: 'contractNumber', headerName: t('Contract No.'), width: 200, isSortable: true },
        { field: 'contractTitle', headerName: t('Contract Title'), width: 300, isSortable: true },
        { field: 'projectNumber', headerName: t('Project No.'), width: 200, isSortable: true },
        { field: 'companyName', headerName: t('Project Company'), width: 200, isSortable: true },
        { field: 'projectName', headerName: t('Project Name'), width: 400, isSortable: true },
        { field: 'manager', headerName: t('Project Manager'), width: 200, isSortable: false },
        { field: 'startDate', headerName: t('Start Date'), width: 200, isSortable: false },
        { field: 'endDate', headerName: t('End Date'), width: 200, isSortable: false },
    ];
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [data, setData] = useState<RecordModel<any>>();

    const permissions = useSelector(selectPermissions)

    useEffect(() => {
        handleTableData()
        // console.log("data", data)
    }, []);

    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const data = await getProjectListingQuery(
            {
                contractNumber: contractNumber?.toString(),
                contractTitle: contractTitle?.toString(),
                projectNumber: projectNumber?.toString(),
                projectName: projectName?.toString(),
                manager: projectManager?.toString(),
                startDate: startDate.format("DD/MM/YYYY").toString(),
                endDate: endDate.format("DD/MM/YYYY").toString(),
                page: pageNumber
            }
        );
        if (data.status === 'fulfilled') {
            return data.data.records.map((item: any) => ({
                id: item?.projectId,
                contractNumber: item?.contractNumber,
                contractTitle: item?.contractTitle,
                projectNumber: item?.projectNumber,
                projectName: item?.projectName,
                companyName: item?.companyName,
                manager: item?.manager,
                startDate: item?.startDate,
                endDate: item?.endDate,
            }))
        }
        // return [];
    };


    const handleTableData = async () => {
        try {
            console.log("getting data")
            if (localStorage.accessToken) {
                getProjectListingQuery(
                    {
                        contractNumber: contractNumber?.toString(),
                        contractTitle: contractTitle?.toString(),
                        projectNumber: projectNumber?.toString(),
                        projectName: projectName?.toString(),
                        manager: projectManager?.toString(),
                        startDate: startDate.format("DD/MM/YYYY").toString(),
                        endDate: endDate.format("DD/MM/YYYY").toString(),
                    }
                ).then(
                    (res) => {
                        if (res.status == 'fulfilled') {

                            const tableRows = res?.data.records.map((item: any) => ({
                                id: item?.projectId,
                                contractNumber: item?.contractNumber,
                                contractTitle: item?.contractTitle,
                                projectNumber: item?.projectNumber,
                                projectName: item?.projectName,
                                companyName: item?.companyName,
                                manager: item?.manager,
                                startDate: item?.startDate,
                                endDate: item?.endDate,
                            }))
                            setTableRows(tableRows)
                            setData(res?.data)
                        }
                    }
                )
            }
        } catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error)
        } finally {
        }
    }


    const handleRowClick = (project: any) => {
        navigate('/project-detail', { state: project });
    };



    return (
        <MainContent type={projectPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer className="data-table-overide-styles">
                    <BigHeading>{t("Project")}</BigHeading>
                    <SearchingBoxContainer>
                        <SearchBox>
                            <FlexContainer>
                                <SearchInput title={t("Contract No.")} value={contractNumber} setMethod={setContractNumber} />
                                <SearchInput title={t("Contract Title")} value={contractTitle} setMethod={setContractTitle} />
                                <SearchInput title={t("Project No.")} value={projectNumber} setMethod={setProjectNumber} />
                                <SearchInput title={t("Project Name")} value={projectName} setMethod={setProjectName} />
                                <SearchInput title={t("Project Manager")} value={projectManager} setMethod={setProjectManager} />
                                <SearchDatePicker title={t("Start Date")} value={startDate} setMethod={setStartDate} />
                                <SearchDatePicker title={t("End Date")} value={endDate} setMethod={setEndDate} />
                            </FlexContainer>

                            <FlexContainer>
                                <LongBlueButton onClick={() => handleTableData()}>{t("Search")}</LongBlueButton>
                            </FlexContainer>

                            {permissions.includes(Permissions.ProjectEdit) &&
                                <FlexContainer>
                                    <LongBlueButton onClick={() => { navigate('/add-project') }}>{t("Add New Project")}</LongBlueButton>
                                </FlexContainer>
                            }
                        </SearchBox>
                    </SearchingBoxContainer>
                    {/* <RecordTable getRowId={e => e.projectId} columns={columns} rows={tableRows} checkbox={false} onClick={handleRowClick}></RecordTable> */}
                    <RecordTableV2
                        columns={columns}
                        rows={tableRows}
                        checkbox={false}
                        pages={data?.totalPages}
                        totalCount={data?.totalCount}
                        onClick={handleRowClick}
                        updateTableRows={setTableRows}
                        fetchDataForPage={fetchDataForPage}
                    ></RecordTableV2>
                </ListContainer>
            </BackgroundStyle>
        </MainContent >
    );
};
export default ProjectListPage;